/**
 * The permission switches the super admin sets in User Management. The server
 * checks them again on every request; this only decides what a page offers.
 */

// Permanently deleting a supplier: always the super admin, and procurement
// while the switch is on.
export const canDeleteSuppliers = (user, permissions) =>
  user?.role === 'super_admin'
  || (user?.role === 'procurement' && permissions?.procurementCanDeleteSuppliers === true);

// Even with the switch on, procurement may delete only a draft or an
// application still in its own review. The server holds the same list.
export const PROCUREMENT_DELETABLE_STATUSES = ['draft', 'submitted', 'under_review', 'pending_procurement'];

export const canDeleteSupplier = (user, permissions, supplier) =>
  canDeleteSuppliers(user, permissions)
  && (user?.role === 'super_admin' || PROCUREMENT_DELETABLE_STATUSES.includes(supplier?.status));
